import { Link } from "@tanstack/react-router";
import type { KeyboardEventHandler, MouseEventHandler } from "react";
import { useI18n } from "../i18n";

export function BrandMark({
  className = "",
  mono = false,
}: {
  className?: string;
  mono?: boolean;
}) {
  return (
    <svg
      className={`brand-mark ${mono ? "brand-mark--mono" : ""} ${className}`.trim()}
      viewBox="0 0 144 96"
      aria-hidden="true"
    >
      <path
        className="brand-mark__body"
        d="M22 65 61 9H96L100 29ZM80 66 105 50 117 84H86Z"
      />
      <path className="brand-mark__tail" d="M7 88 19 73 56 58 37 88Z" />
      <path className="brand-mark__thrust" d="M37 88 56 58 137 20Z" />
    </svg>
  );
}

export function Brand({
  inverse = false,
  onContextMenu,
  onKeyDown,
  showChinese = true,
}: {
  inverse?: boolean;
  onContextMenu?: MouseEventHandler<HTMLAnchorElement>;
  onKeyDown?: KeyboardEventHandler<HTMLAnchorElement>;
  showChinese?: boolean;
}) {
  const { l } = useI18n();
  return (
    <Link
      className={`brand ${inverse ? "brand--inverse" : ""}`}
      to="/"
      aria-label={l("加速科学 AccSci 首页", "AccSci home")}
      onContextMenu={onContextMenu}
      onKeyDown={onKeyDown}
    >
      <BrandMark className="brand__mark" />
      <span className="brand__wordmark">
        <strong>AccSci</strong>
        {showChinese && <small>{l("加速科学", "Acceleration Science")}</small>}
      </span>
    </Link>
  );
}

export function Arrow({
  direction = "right",
}: {
  direction?: "right" | "down" | "up-right";
}) {
  const paths = {
    right: "M5 12h14m-5-5 5 5-5 5",
    down: "M12 5v14m-5-5 5 5 5-5",
    "up-right": "M7 17 17 7m-8 0h8v8",
  };
  return (
    <svg className="icon-arrow" viewBox="0 0 24 24" aria-hidden="true">
      <path d={paths[direction]} />
    </svg>
  );
}

export function DataGlyph({ variant = 0 }: { variant?: number }) {
  if (variant % 3 === 1) {
    return (
      <svg viewBox="0 0 120 120" aria-hidden="true">
        <circle cx="60" cy="60" r="38" />
        <circle cx="60" cy="60" r="20" />
        <path d="M60 8v32M60 80v32M8 60h32M80 60h32" />
      </svg>
    );
  }
  if (variant % 3 === 2) {
    return (
      <svg viewBox="0 0 120 120" aria-hidden="true">
        <path d="m20 88 22-54 20 36 14-24 24 42H20Z" />
        <path d="M20 98h80M30 22h60" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 120 120" aria-hidden="true">
      <path d="M18 26h84v68H18zM18 48h84M42 48v46M78 48v46" />
      <circle cx="30" cy="37" r="3" className="fill" />
    </svg>
  );
}
